import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useTranslation } from 'react-i18next';
import { AuthProvider, useAuth } from '@/lib/auth';
import { SessionsProvider } from '@/lib/sessions';

import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import MachinesPage from '@/pages/MachinesPage';
import DocumentsPage from '@/pages/DocumentsPage';
import DiagnosticChatPage from '@/pages/DiagnosticChatPage';
import GuidedDiagnosisPage from '@/pages/GuidedDiagnosisPage';
import InterventionsPage from '@/pages/InterventionsPage';
import AdminPage from '@/pages/AdminPage';
import FieldReportsPage from '@/pages/FieldReportsPage';
import ProcedurePatternsPage from '@/pages/ProcedurePatternsPage';
import UniversalProceduresPage from '@/pages/UniversalProceduresPage';
import ProfilePage from '@/pages/ProfilePage';
import AppShell from '@/components/AppShell';

function Protected({ children, admin = false }) {
  const { user, loading } = useAuth();
  const { t } = useTranslation();
  if (loading) return <div className="p-8 text-gray-500">{t('app.loading')}</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== 'admin') return <Navigate to="/" replace />;
  return <AppShell>{children}</AppShell>;
}

export default function App() {
  return (
    <AuthProvider>
      <SessionsProvider>
        <BrowserRouter>
          <Toaster position="top-right" />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<Protected><DashboardPage /></Protected>} />
            <Route path="/macchine" element={<Protected><MachinesPage /></Protected>} />
            <Route path="/documenti" element={<Protected><DocumentsPage /></Protected>} />
            <Route path="/diagnosi" element={<Protected><DiagnosticChatPage /></Protected>} />
            <Route path="/diagnosi-guidata" element={<Protected><GuidedDiagnosisPage /></Protected>} />
            <Route path="/interventi" element={<Protected><InterventionsPage /></Protected>} />
            <Route path="/field-reports" element={<Protected><FieldReportsPage /></Protected>} />
            <Route path="/procedure-patterns" element={<Protected><ProcedurePatternsPage /></Protected>} />
            <Route path="/universal-procedures" element={<Protected><UniversalProceduresPage /></Protected>} />
            <Route path="/profilo" element={<Protected><ProfilePage /></Protected>} />
            <Route path="/admin" element={<Protected admin><AdminPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </SessionsProvider>
    </AuthProvider>
  );
}
